import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { reasons, ReasonType, State } from './types';
import useStyles from '../useStyles';
import { clsx } from '@components/Provider';
import OutlinedTextField from '@routes/Common/OutlinedTextField';
import { Box, Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import getScopes from '@utils/getScopes';
import { CapaServiceType } from '@generated/graphql';
import CapaLogo from '../assets/CapaLogo.png';
import PartnersLogo from '../assets/PartnersLogo.png';
import ConnectLogo from '../assets/ConnectLogo.png';
import { Check } from '@material-ui/icons';
import SmsFailedIcon from '@material-ui/icons/SmsFailed';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import { useHistory } from 'react-router-dom';

interface Props {
  matches: boolean;
  isExistChatRooms: boolean;
  onSubmit: () => void;
  onChangeRoute: (_path: string) => void;
}

const checkList: { name: keyof State; sublist: React.ReactNode }[] = [
  {
    name: 'check1',
    sublist: (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={22}
        >
          CAPA 회원은 언제든지 탈퇴 의사를 통지함으로써&nbsp;
          <span className="strong">서비스 이용 계약을 해지</span>할 수 있습니다.
        </CustomizedTypography>

        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span>1.</span>다만, 탈퇴 의사를 통지하기 전 모든 상담 중 프로젝트를
          완료, 철회 또는 취소해야 합니다. 이 경우 거래 건의 철회 또는 취소로
          인한 불이익은 본인이 부담하여야 합니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span>2.</span>상기 1항의 조치를 마치지 않고 탈퇴를 진행하는 경우,
          탈퇴 신청 후부터 30일 동안 서비스에 로그인하여 상담 중인 프로젝트를
          완료, 철회 또는 취소할 수 있으며, 이 기간동안 새로운 프로젝트를
          진행하는 기능은 모두 제한됩니다. 탈퇴 신청 30일 경과 후에는 모든
          상담이 일괄 종료되며 최종 탈퇴 처리됩니다.
        </CustomizedTypography>
      </>
    )
  },
  {
    name: 'check2',
    sublist: (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={22}
        >
          회원 탈퇴 이후에는&nbsp;
          <span className="strong">
            CAPA의 모든 서비스를 이용할 수 없고 서비스 이용 기록이 삭제됨
          </span>
          을 확인하였습니다.
        </CustomizedTypography>

        <CustomizedTypography variant="body2" color="textSecondary">
          회원 탈퇴는 CAPA의 모든 서비스(CAPA, CAPA 파트너스, CAPA 클라우드,
          CAPA 커넥트)에 적용되는 통합 계정을 삭제하는 것으로 탈퇴 진행 시 이용
          중이던 모든 서비스에 다시 로그인 할 수 없고 모든 계정 정보 및 이용
          기록이 삭제됩니다. 탈퇴 이후에는 모든 기록을 복구할 수 없습니다.
          고객님이 이용 중이신 서비스와 삭제되는 데이터 목록은 아래 사항을 참고
          해주세요.
        </CustomizedTypography>
      </>
    )
  },
  {
    name: 'check3',
    sublist: (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={22}
        >
          회원 탈퇴한&nbsp;
          <span className="strong">CAPA 아이디는 복구할 수 없음</span>을
          확인하였습니다.
        </CustomizedTypography>
        <CustomizedTypography variant="body2" color="textSecondary">
          회원 탈퇴 진행 시 계정과 해당 계정으로 활동한 기록 모두 복구가
          불가능합니다.
        </CustomizedTypography>
      </>
    )
  },
  {
    name: 'check4',
    sublist: (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={22}
        >
          회원 탈퇴 이후에도 진행한 프로젝트의&nbsp;
          <span className="strong">
            채팅 기록, 수령 견적서, 발행 발주서는 별도 보관됨
          </span>
          을 확인하였습니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          gutterBottoms={20}
        >
          개인정보처리방침에 명시된 예외적 보관 사유에 근거하여, 고객님이
          진행했던 프로젝트 채팅 기록과 수령한 견적서, 발행한 발주서는
          보관됩니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span className="bullet">•</span>전자상거래 등에서의 소비자보호에 관한
          법률 제6조 및 시행령 제6조에 의해 계약 또는 청약철회 등에 관한 기록은
          5년간 보존합니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span className="bullet">•</span>전자상거래 등에서의 소비자보호에 관한
          법률 제6조 및 시행령 제6조에 의해 대금 결제 및 재화 등의 공급에 관한
          기록은 5년간 보존합니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span className="bullet">•</span>전자상거래 등에서의 소비자보호에 관한
          법률 제6조 및 시행령 제6조에 의해 소비자의 불만 또는 분쟁 처리에 관한
          기록은 3년간 보존합니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          className="has-sublist"
        >
          <span className="bullet">•</span>통신비밀보호법 제15조의 2 및 시행령
          제41조에 의해 접속에 관한 기록은 3개월간 보존합니다. 부정거래의 관리에
          의해 부정 이용 기록은 6개월간 보존합니다.
        </CustomizedTypography>
      </>
    )
  },
  {
    name: 'check5',
    sublist: (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
        >
          위의 유의 사항 및 안내를 모두 확인하였으며 회원 탈퇴 진행하겠습니다.
        </CustomizedTypography>
      </>
    )
  }
];

const ConfirmMembershipPresenter = ({
  matches,
  isExistChatRooms,
  onSubmit,
  onChangeRoute
}: Props) => {
  const classes = useStyles();

  const {
    control,
    errors,
    getValues,
    setValue,
    clearErrors,
    watch
  } = useFormContext<State>();
  const { scopes } = getScopes();

  const { reason, check1, check2, check3, check4, check5 } = getValues();
  const { etcReason } = watch();

  const isComplete = () => {
    if (reason === 'ETC') {
      return etcReason && check1 && check2 && check3 && check4 && check5;
    }
    return reason && check1 && check2 && check3 && check4 && check5;
  };

  const history = useHistory();

  return (
    <div className={classes['Member-Withdrawal-ConfirmMembership-root']}>
      <Controller
        defaultValue=""
        name="reason"
        control={control}
        rules={{
          required: true
        }}
        render={({ value }) => (
          <div className="reason-root" id="reason-list">
            {Object.keys(reasons).map((reason, index) => (
              <>
                <div
                  key={index}
                  className={clsx('reason', {
                    active: value?.includes(reason as ReasonType),
                    'error': errors['reason'] ? true : false
                  })}
                  onClick={() => {
                    clearErrors('reason');

                    setValue('reason', reason);
                  }}
                >
                  <CustomizedTypography variant="body2" color="textSecondary">
                    {reasons[reason as keyof typeof reasons]}
                  </CustomizedTypography>
                </div>
                {((!matches && reason === 'PERSONAL_INFORMATION_LEAKAGE') ||
                  (matches && reason === 'USELESS_ALARM')) &&
                  getValues('reason') === 'USELESS_ALARM' && (
                    <Box
                      mb={2}
                      p={3}
                      className={classes.notificationSettingBox}
                    >
                      <Grid container direction="column" spacing={1}>
                        <Grid item>
                          <SmsFailedIcon className="notificationSettingBox-icon" />
                        </Grid>
                        <Grid item>
                          <CustomizedTypography
                            variant="body2"
                            color="textPrimary"
                          >
                            혹시 이메일, 문자메시지에 대한 불편으로 인해 회원
                            탈퇴를 신청하시나요?
                          </CustomizedTypography>
                          <CustomizedTypography
                            variant="body2"
                            color="textPrimary"
                          >
                            알림 설정에서 원하는 알림만 받도록 설정할 수
                            있습니다.
                          </CustomizedTypography>
                        </Grid>
                        <Grid item container alignItems="center">
                          <CustomizedTypography
                            variant="body2"
                            color="primary"
                            className="notificationSettingBox-link"
                            onClick={() => history.push('/mypage/notification')}
                          >
                            알림 설정으로 이동하기
                          </CustomizedTypography>
                          <ArrowForwardIosOutlinedIcon
                            color="primary"
                            fontSize="small"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}
              </>
            ))}
          </div>
        )}
      />

      <div className="extra-reason-root">
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          gutterBottoms={16}
        >
          이외의 탈퇴 사유가 있다면 적어주세요.
        </CustomizedTypography>

        <Controller
          control={control}
          name="etcReason"
          defaultValue=""
          rules={{
            required: getValues('reason') === 'ETC'
          }}
          render={(renderProps) => (
            <div className="extra-reason-input">
              <OutlinedTextField
                {...renderProps}
                className="extra-input"
                multiline
                fullWidth
                minRows={5}
                maxRows={5}
                placeholder={
                  getValues('reason') === 'ETC'
                    ? '기타 탈퇴사유를 적어주세요 (필수 사항)'
                    : '탈퇴하시려는 이유를 적어주세요 (선택 사항)'
                }
                error={
                  getValues('reason') === 'ETC' && errors['etcReason']
                    ? true
                    : false
                }
              />

              {errors['etcReason'] && (
                <CustomizedTypography
                  className="error"
                  color="error"
                  variant="body2"
                  fontWeight="normal"
                >
                  기타 탈퇴사유 입력은 필수입니다.
                </CustomizedTypography>
              )}
            </div>
          )}
        />
      </div>

      <div id="check-list" className="check-list-root">
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          gutterBottoms={32}
        >
          탈퇴 유의사항 및 안내를 확인하고 체크해주세요.
        </CustomizedTypography>

        {checkList.map((list, index) => (
          <Controller
            key={index}
            name={list.name}
            defaultValue={false}
            control={control}
            rules={{
              required: true
            }}
            render={(renderProps) => (
              <div
                className={clsx('check-list-item', {
                  active: renderProps.value,
                  error: errors[list.name] ? true : false
                })}
                onClick={() => {
                  const check1 = getValues(list.name);
                  clearErrors(list.name);
                  setValue(list.name, !check1);
                }}
              >
                {list.sublist}

                {list.name === 'check2' && (
                  <div className="sublist-root">
                    {scopes.map((scope, index) => {
                      return (
                        <React.Fragment key={index}>
                          {scope === CapaServiceType.Quotation && (
                            <div className="sub-list">
                              <div className="flex-box">
                                <img src={CapaLogo} alt="" />
                                <CustomizedTypography
                                  variant="body1"
                                  fontWeight="500"
                                  color="textPrimary"
                                >
                                  캐파
                                </CustomizedTypography>
                              </div>

                              {matches ? (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  &nbsp;•&nbsp;견적요청서 내 요청 정보 및 도면
                                  <br />
                                  &nbsp;•&nbsp;프로젝트 채팅 기록 및 첨부파일
                                </CustomizedTypography>
                              ) : (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  견적요청서 내 요청 정보 및 도면, 프로젝트 채팅
                                  기록 및 첨부파일
                                </CustomizedTypography>
                              )}
                            </div>
                          )}

                          {scope === CapaServiceType.QuotationPartner && (
                            <div className="sub-list">
                              <div className="flex-box">
                                <img src={PartnersLogo} alt="" />
                                <CustomizedTypography
                                  variant="body1"
                                  fontWeight="500"
                                  color="textPrimary"
                                >
                                  캐파 파트너스
                                </CustomizedTypography>
                              </div>

                              {matches ? (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  &nbsp;•&nbsp;회사소개서 정보 및 첨부파일
                                  <br />
                                  &nbsp;•&nbsp;프로젝트 채팅 기록 및 첨부파일
                                </CustomizedTypography>
                              ) : (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  회사소개서 정보 및 첨부파일, 프로젝트 채팅
                                  기록 및 첨부파일
                                </CustomizedTypography>
                              )}
                            </div>
                          )}

                          {scope === CapaServiceType.Connect && (
                            <div className="sub-list">
                              <div className="flex-box">
                                <img src={ConnectLogo} alt="" />
                                <CustomizedTypography
                                  variant="body1"
                                  fontWeight="500"
                                  color="textPrimary"
                                >
                                  캐파 커넥트
                                </CustomizedTypography>
                              </div>
                              {matches ? (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  &nbsp;•&nbsp;드라이브 내 업로드된 파일 <br />
                                  &nbsp;•&nbsp;연락처 목록
                                  <br />
                                  &nbsp;•&nbsp;그룹 및 그룹 내 채팅/어노테이션
                                  기록
                                </CustomizedTypography>
                              ) : (
                                <CustomizedTypography
                                  variant="body2"
                                  color="textPrimary"
                                >
                                  드라이브 내 업로드된 파일, 연락처 목록, 그룹
                                  및 그룹 내 채팅/어노테이션 기록
                                </CustomizedTypography>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}

                {matches ? (
                  <FormControlLabel
                    classes={{
                      root: renderProps.value ? 'checked' : undefined
                    }}
                    label={
                      renderProps.value ? (
                        <>
                          <Check /> 확인 완료
                        </>
                      ) : (
                        '네, 확인하였습니다.'
                      )
                    }
                    onChange={(e, checked) => {
                      clearErrors(list.name);
                      setValue(list.name, checked);
                    }}
                    control={<Checkbox color="primary" />}
                  />
                ) : (
                  <Checkbox
                    checked={renderProps.value ? true : false}
                    color="primary"
                  />
                )}
              </div>
            )}
          />
        ))}
      </div>

      <div className={classes['next-stage-cta']}>
        <CustomizedButton
          fullWidth
          variant="contained"
          color={isComplete() ? 'primary' : 'default'}
          size="large"
          onClick={onSubmit}
        >
          {isExistChatRooms ? '다음 단계' : '탈퇴하기'}
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          variant="outlined"
          color="default"
          size="large"
          onClick={() => onChangeRoute('/mypage')}
        >
          취소
        </CustomizedButton>
      </div>
    </div>
  );
};

export default ConfirmMembershipPresenter;
